import { Pagination } from '@mui/material';
import { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router-dom';
import * as Alert from '../../../../components/Alert/Alert';
import { useAppSelector } from '../../../../reduxService/hooks';
import { IProjectBaseResponse } from '../../../api/IApiResponse';
import * as BeMaccaferriStoreHelper from '../../../api/store/BeMaccaferriStoreHelper';
import { endpoint } from '../../../pages';
import { selectUser } from '../../../store/user/userSlice';
import { IRecentProjectsProps } from './IRecentProjects';
import ProjectItem from './ProjectItem/ProjectItem';

const MIN_PROJECT_PAGE_SIZE = 4;

const RecentProjects = (props: IRecentProjectsProps) => {
    const { t, i18n } = useTranslation();
    const navigate = useNavigate();

    const [projects, setProjects] = useState<IProjectBaseResponse[]>([]);
    const user = useAppSelector(selectUser);

    const [page, setPage] = useState<number>(1);
    const [totalPages, setTotalPages] = useState<number>(0);

    const fetchProjects = async (page: number) => {
        let projectByCompany = await BeMaccaferriStoreHelper.getProjectsByAuthorAsync(user.data!.email!, page, MIN_PROJECT_PAGE_SIZE);
        setProjects(projectByCompany.data.data);
        setTotalPages(projectByCompany.data.pagesCount);
    };

    useEffect(() => {
        if (!!user.data?.email) {
            fetchProjects(1);
        }
    }, [user.data]);

    const handleClick = async (e: any, project: IProjectBaseResponse) => {
        if (!!props.onClose) {
            props.onClose();
        }
        navigate(endpoint.designCondition + `/${project.id}`);
    };

    const handleDelete = async (e: any, project: IProjectBaseResponse) => {
        Alert.warning(t('recent_projects_alert_warning_title'), t('recent_projects_alert_warning_body') as string, true).then(async result => {
            if (result.isConfirmed) {
                let isDeleted = await BeMaccaferriStoreHelper.deleteProjectByIdAsync(project.id!);
                if (isDeleted) {
                    let newProjects = projects!.filter(proj => proj.id !== project.id);
                    setProjects(newProjects);
                    Alert.success(t('recent_projects_alert_success_title'), t('recent_projects_alert_success_body') as string);
                }
            }
        });
    };

    const handlePageChange = (page: number) => {
        fetchProjects(page);
        setPage(page);
    };

    return (
        <>
            <h5>{t('home_recent_projects_table_title')}</h5>
            {projects.length > 0 ? (
                <>
                    <div className='d-flex p-1 me-3'>
                        <label className='w-30 me-5'>{t('home_recent_projects_table_name')}</label>
                        <label className='w-30 me-5'>{t('home_recent_projects_table_last_update')}</label>
                        <label className='w-30'>{t('home_recent_projects_table_type')}</label>
                    </div>
                    <hr />
                    {projects.map((project: IProjectBaseResponse, index: number) => (
                        <ProjectItem project={project} onClick={e => handleClick(e, project)} onDelete={e => handleDelete(e, project)} key={index} />
                    ))}
                    {page <= totalPages && totalPages !== 1 && (
                        <Pagination count={totalPages} page={page} onChange={(e, value) => handlePageChange(value)} className='d-flex justify-content-end mt-3' />
                    )}
                </>
            ) : (
                <span>{t('empty')}</span>
            )}
        </>
    );
};

export default RecentProjects;
